import { icons_exports } from "./icons.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/iconLookup.tsx
var NON_ICON_KEYS = [
	"Iconize",
	"IconTypes",
	"IconProps",
	"IconBase"
];
var ICON_NAMES = Object.keys(icons_exports).filter((key) => !NON_ICON_KEYS.includes(key));
var getIconComponent = (iconName) => {
	if (!iconName) return null;
	return icons_exports[iconName];
};
/**
* Icon component that dynamically renders an icon based on the provided name.
* Acts as a wrapper around all available Icon in the system, allowing for runtime selection with type safety
*/
var DynamicIcon = ({ name, ...iconProps }) => {
	const IconComponent = getIconComponent(name);
	if (!IconComponent) return null;
	return /* @__PURE__ */ jsx(IconComponent, { ...iconProps });
};
//#endregion
export { DynamicIcon, ICON_NAMES };
